import React from 'react';
import cn from 'classnames';
import { FontWeight } from 'apps/sigma2-ui/src/components/utils/tailwind-overrides';
import { TextSize } from 'apps/sigma2-ui/src/components/utils/tailwind-overrides';
import { computeClassNamesForTextSize } from 'apps/sigma2-ui/src/lib/text';
import { TextProps } from 'apps/sigma2-ui/src/lib/text';

const defaultFontWeightClassMap: Record<TextProps['tagName'], FontWeight> = {
  h1: 'font-bold',
  h2: 'font-bold',
  h3: 'font-bold',
  h4: 'font-bold',
  h5: 'font-bold',
  h6: 'font-bold',
  div: 'font-normal',
  span: 'font-normal',
  p: 'font-normal',
};

const defaultTextSizeMap: Record<TextProps['tagName'], TextSize> = {
  h1: 'text-3xl',
  h2: 'text-2xl',
  h3: 'text-xl',
  h4: 'text-lg',
  h5: 'text-base',
  h6: 'text-base',
  div: 'text-base',
  span: 'text-base',
  p: 'text-base',
};

const defaultTextColor = 'text-secondary';
const defaultFontFamily = 'font-sans';

/**
 * @deprecated Use the `Typography` component instead.
 * @see Typography
 */
export const Text: React.FC<TextProps> = (props) => {
  const {
    tagName,
    textColor,
    fontFamily,
    fontWeight,
    children,
    className,
    textSize,
    ...rest
  } = props;

  // TODO: Does it make sense for this to get less bold when screen size is smaller?
  const effectiveFontWeight = fontWeight ?? defaultFontWeightClassMap[tagName];

  const effectiveTextColor = textColor ?? defaultTextColor;

  const effectiveFontFamily = fontFamily ?? defaultFontFamily;

  const defaultTextSize = textSize ?? defaultTextSizeMap[tagName];

  const effectiveTextSize = computeClassNamesForTextSize({
    ...props,
    textSize: defaultTextSize,
  });

  return React.createElement(
    tagName,
    {
      ...rest,
      className: cn(
        effectiveFontWeight,
        effectiveTextColor,
        effectiveFontFamily,
        effectiveTextSize,
        className,
      ),
    },
    children,
  );
};
